import { Outlet } from 'react-router-dom';
import MarketingNav from './MarketingNav';
import MarketingFooter from './MarketingFooter';

/**
 * The shared frame for every marketing page. Wraps the outlet in a
 * fixed nav (with 80px offset via pt-20 handled per-page hero), and a
 * dark navy footer. No page-specific chrome should live here.
 */
export default function MarketingLayout() {
  return (
    <div className="min-h-screen bg-white text-[#0B132B] antialiased" data-testid="marketing-layout">
      <MarketingNav />
      <main>
        <Outlet />
      </main>
      <MarketingFooter />
    </div>
  );
}
